import { memo } from 'react'
import { createPortal } from 'react-dom'
import { AnimatePresence } from 'framer-motion'

import * as Styled from './styled'
import { IProps } from './types'

const NO_ANIMATION = { duration: 0, ease: 'easeInOut' as const }

const SlideUp = ({
  isOpen,
  className,
  children,
  onClose,
  isHidden = false,
  bottomMargin = 64,
  disableAnimation,
  zIndex,
  minHeight,
  maxHeight
}: IProps) => {
  return (
    document.body &&
    createPortal(
      <AnimatePresence>
        {isOpen && (
          <>
            <Styled.GlobalScrollBlock />
            <Styled.Container className={className} $zIndex={zIndex}>
              <Styled.BackdropOverlay onClick={onClose} />
              <Styled.Content
                data-slide-up-content=""
                initial={{ opacity: 0, y: 50 }}
                animate={
                  isHidden ? { opacity: 0, y: 50 } : { opacity: 1, y: 0 }
                }
                exit={{ opacity: 0, y: 50 }}
                transition={
                  disableAnimation
                    ? NO_ANIMATION
                    : {
                        duration: 0.2,
                        ease: 'easeInOut'
                      }
                }
                $bottomMargin={bottomMargin}
                $minHeight={minHeight}
                $maxHeight={maxHeight}
              >
                <Styled.CloseLine onClick={onClose} />
                {children}
              </Styled.Content>
            </Styled.Container>
          </>
        )}
      </AnimatePresence>,
      document.body
    )
  )
}

export default memo(SlideUp)
